const parseRangeFromFilterValue = (rangeString: string): [number, number] => {
    let minValue = -Infinity;
    let maxValue = Infinity;

    const cleanInitialValue = rangeString.replace('[', '').replace(']', '');

    if (cleanInitialValue) {
        const minRaw = cleanInitialValue.split(' ')[0];
        const maxRaw = cleanInitialValue.split(' ')[2];

        if (minRaw !== '*') {
            minValue = parseFloat(minRaw);
        }
        if (maxRaw !== '*') {
            maxValue = parseFloat(maxRaw);
        }
    }

    return [minValue, maxValue];
};

export default parseRangeFromFilterValue;
